import $ from "jquery";
import {getFileByService, getFileIconByExtension} from "@/helpers/file-helper";
import {createElementFromHTML} from "@/helpers/datatable/datatable-editor-helper";
import {getWhiteListExtensions} from "@/helpers/bookmark-settings-helper";
import {getToken} from "@/helpers/auth/auth-helper";

export function getDataTableEditorFields(dataTable, hiddenColumns, isStandAlone = false) {
    const fields = []
    dataTable.dynamicSelect = []

    const token = getToken()

    dataTable.attributes.map((attribute, key) => {

        let field = {}
        field.attr = {};
        field.label = attribute.DisplayName
        field.type = 'hidden'

        if(!attribute.MutationTypeID) {
            attribute.MutationTypeID = attribute.AttributeTypeID
        }

        switch (attribute.MutationTypeID) {
            case 6:  // Default
            case 11:    // Tekst
                field.type = 'text'
                break;
            case 13:  // checkbox
                field.type = 'checkbox'


                const options = []

                attribute.DomainList.domain_list_items.map(item => {
                    options.push({label: item.Name, value: item.Value})
                })

                field.options = [options[1]]

                field.separator = '';
                field.unselectedValue = options[0].value;
                break;
            case 14: // Radio
                field.type = 'radio'
                field.options = []

                let defaultRadioValue = null
                attribute.DomainList.domain_list_items.map(item => {
                    if(item.Active === 1) {
                        defaultRadioValue = item.Value
                    }
                    field.options.push({label: item.Name, value: item.Value})
                })
                field.unselectedValue = '';
                field.default = defaultRadioValue

                break;
            case 15:  // Textarea
                field.type = 'textarea'
                break;
            case 61: // input foto
            case 16: // input bestand
                field.attr = {}

                if(attribute.ActionAdvancedThird) {
                    if(attribute.ActionAdvancedThird.includes(';')) {
                        field.attr.accept = '.' + attribute.ActionAdvancedThird.split(';').join(',.') //replaceAll(';', ',.')
                    } else {
                        field.attr.accept = '.' + attribute.ActionAdvancedThird
                    }
                } else {
                    field.attr.accept = getWhiteListExtensions()
                }

                field.type = 'upload';
                if(attribute.ActionAdvanced !== null && attribute.ActionAdvanced !== '' && attribute.ActionAdvanced > 1) {
                    field.type = 'uploadMany';
                    field.limit = attribute.ActionAdvanced;
                    field.name = attribute.Attribute + '[]';
                    // Set default is empty to prevent DataTables error
                    field.default = ''
                }


                field.ajax = {
                    type: 'POST',
                    url:  window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/domain/' + dataTable.DomainID + '/presentation/' + dataTable.PresentationID + '/mutation/' + dataTable.FormID + '/upload',
                }

                if(token) {
                    field.ajax.headers = {
                        "Authorization": token
                    }
                }

                field.clearText = 'Verwijderen <i class="fa fa-trash"></i>';
                field.noImageText = 'Geen bestand gekozen';
                field.noFileText = 'Geen bestand gekozen';
                field.processingText = 'Bestand wordt ingelezen';
                field.fileReadText = 'Bestand wordt ingelezen';
                field.uploadText = 'Kies bestand...';
                field.dragDropText = 'Sleep en plaats een bestand om het te uploaden';
                field.dragDrop = false;
                field.ajaxData = function (fd) {
                    fd.append('csrf_name', $('meta[name="csrf-token-name"]').attr('content'));
                    fd.append('csrf_value', $('meta[name="csrf-token-value"]').attr('content'));
                }

                field.opts = {}
                field.opts.action = attribute.Action
                field.opts.maxHeight = attribute.ActionAdvancedSecond

                field.display = function (result, key) {
                    const fileName = result.fileName;

                    if (result.csrf !== undefined) {
                        $('meta[name="csrf-token-name"]').attr('content', result.csrf.name);
                        $('meta[name="csrf-token-value"]').attr('content', result.csrf.value);
                    }

                    if (fileName !== null && typeof fileName === 'string') {
                        const extension = fileName.split('.')[1];
                        if (extension !== undefined && extension !== null) {
                            const fileIconExtension = getFileIconByExtension(extension);

                            if (fileIconExtension.isImage) {
                                getFileByService(`${window.kaartViewerUrl}/admin/v2/kaartviewerapi/bookmark/${window.websiteID}/domain/${dataTable.DomainID}/presentation/${dataTable.PresentationID}/mutation/${dataTable.FormID}/upload/temp/${fileName}`).then(blob => {
                                    document.querySelector(`#upload-image-${attribute.ID}-` + key).src = URL.createObjectURL(blob)
                                })
                                return `<img id="upload-image-${attribute.ID}-${key}"/>`;
                              } else if(fileIconExtension.isVideo !== false) {
                                return   '<video width="100%"" controls autoplay muted loop>' +
                                    '    <source src="' + window.kaartViewerUrl + '/admin/rest/api/filemanager/upload/temp/' + fileName + '" type="' + fileIconExtension.isVideo + '">' +
                                    '</video>';
                            } else {
                                return '<i class="' + fileIconExtension.icon + '"></i> ' + fileName;
                            }
                        }
                    }

                    return '';
                };
                field.noImageText = 'Geen afbeelding gevonden';
                break;
            case 12: // Input keuzelijst enkel
                field.type = 'select2'
                field = generateSelectizeOptions(dataTable, field, attribute)
                break;

            case 17: // Input keuzelijst vrij
                field.type = 'select2'
                field = generateSelectizeOptions(dataTable, field, attribute)
                field.opts.tags = true;
                break;
            case 18: // Input keuzelijst multi
                field.type = 'select2'
                field = generateSelectizeOptions(dataTable, field, attribute)
                field.attr.multiple = true;
                field.separator = ";";
                break;
            case 28: // Wachtwoord
                field.type = 'password'
                break;
            case 8:  // read only lengte
                field.type = "hidden";
                field.opts = {}
                field.opts.type = 'length'
                break;
            case 9:  // read only oppervlakte
                field.type = "hidden";
                field.opts = {}
                field.opts.type = 'area'
                break;
            case 24: // Punt geom
            case 240: // Punt multi geom
            case 25: // Lijn geom
            case 250: // Lijn multi geom
            case 26: // Vlak geom
            case 260: // Vlak multi geom
            case 29: // Verborgen
            case 27: // Insert geom
                field.type = 'hidden'
                if (hiddenColumns) {
                    hiddenColumns.push(
                        {
                            target: key + 1,
                            visible: false,
                            searchable: false,
                        })
                }
                break;
            case 30: // Input mail
                if ( (attribute.Action === 1 || attribute.Action === 2) && attribute.DomainList !== null) {
                    field.type = 'select2'
                    field = generateSelectizeOptions(dataTable, field, attribute)
                    field.attr.multiple = true;
                    field.separator = ";";
                    if(attribute.Action === 2) {
                        field.opts.tags = true;
                    }
                } else {
                    if(attribute.Action === 2) {
                        field.type = 'text'
                    } else {
                        field.type = 'hidden'
                    }
                }
                break;
            case 32: // Input color
                field.type = 'color'
                break;
            case 60: // DateTime
                field.type = 'datetime'

                if(!attribute.Type) {
                    attribute.Type = attribute.attribute.Type
                }

                switch (attribute.Type) {
                    case 402:
                        // Date time format
                        field.wireFormat = 'D-M-YYYY';
                        field.displayFormat = 'D-M-YYYY';
                        field.format = 'D-M-YYYY';
                        break;
                    default:
                        // Date time format
                        field.wireFormat = 'D-M-YYYY kk:mm';
                        field.displayFormat = 'D-M-YYYY kk:mm';
                        break;
                }

                field.def = function () {
                    return new Date();
                };

                field.opts = {};
                // field.opts.momentLocale = 'nl';
                field.opts.yearRange = 20;
                break;
        }

        if(field.type) {
            if (attribute.IsRequired === 1) {
                field.label += ' <span class="fa fa-asterisk fa-mandatory"></span>';
                field.attr.required = true;
            }
            field.name = attribute.Attribute

            if(attribute.MutationTypeID !== 60 || (attribute.MutationTypeID === 60 && !attribute.DefaultValue)) {
                field.def = attribute.DefaultValue
             }

            field.attr.placeholder = attribute.Placeholder;
            if(attribute.FieldInfo) {
                field.fieldInfo = attribute.FieldInfo;
            }

            if(!isStandAlone) {
                field.data = function (row) {

                    const value = row[attribute.Attribute]
                    if (typeof value == 'number') {
                        return value
                    }
                    const element = createElementFromHTML(value)

                    if(value) {
                        if (value.includes('layer-info-info-type-url') && element.querySelector('a')) {
                            return element.querySelector('a').href
                        }
                        if (value.includes('layer-info-info-type-date') && element.querySelector('layer-info-info-type-date')) {
                            return element.querySelector('layer-info-info-type-date').innerText.replace(element.querySelector('layer-info-info-type-date span').innerText, '')
                        }
                    }

                    if (!element.firstChild) {
                        return value
                    }
                    if (!element.firstChild.firstChild) {
                        return ''
                    }

                    if(element.firstChild.dataset.value) {
                        return element.firstChild.dataset.value
                    }

                    return element.firstChild.firstChild.data
                }
            }

            fields.push(field)

            const fieldOld = {};
            fieldOld.name = field.name + '_old';
            fieldOld.type = 'hidden';
            fieldOld.default = '';

            if(attribute.Value) {
                fieldOld.default = attribute.Value;
            }

            fields.push(fieldOld);
        }
    })

    return {
        fields: fields,
        hiddenColumns: hiddenColumns,
        dynamicFields: dataTable.dynamicSelect
    }
}

export function generateSelectizeOptions(dataTable, field, attribute) {
    field.options = []

    if(attribute.DomainList) {

        if (attribute.DomainList.Automatic === 0 && attribute.DomainList.domain_list_items.length > 0) {

            let hasOption = false
            attribute.DomainList.domain_list_items.map(item => {
                if(String(attribute.Value) === String(item.Value)) {
                    hasOption = true
                }
                field.options.push({label: item.Name, value: item.Value})
            })

            if(!hasOption && attribute.Value) {
                field.options.push({label: attribute.Value , value: attribute.Value })
            }

        } else {
            const DomainListDependentID = attribute.DomainList.DomainListDependentID

            const dynamicSelect = {
                columnName: attribute.Attribute,
                column: attribute.FormAttributeID
            }

            if (DomainListDependentID) {
                if(dataTable.featureInfo.records && dataTable.featureInfo.records.length === 1) {
                    dynamicSelect.parentValue = dataTable.featureInfo.records[0].attributes.find(
                        attribute => attribute[0].DomainList && attribute[0].DomainList.ID === DomainListDependentID
                    )[0].Value
                }

                if(!dynamicSelect.parentValue) {
                    dynamicSelect.parentValue = dataTable.attributes.find(
                        attribute => attribute.DomainList && attribute.DomainList.ID === DomainListDependentID
                    ).Value
                }
            }

            dynamicSelect.child_name = dataTable.attributes.find(
                dataTableAttribute => dataTableAttribute.domain_list?.domain_list_dependent_parent?.Attribute === attribute.Attribute
            )?.Attribute

            console.log(dynamicSelect)

            // console.log(dynamicSelect)
            // console.log(attribute.DomainList)

            dataTable.dynamicSelect.push(dynamicSelect)
        }
    }

    field.opts = {};
    field.opts.allowClear = true;
    field.opts.dropdownPosition = 'below';
    field.opts.dropdownParent = '.modal';
    field.opts.placeholder = {
        id: "",
        text: attribute.Placeholder
    };
    field.opts.language = {};
    field.opts.language.noResults = function() {
        return "Geen resultaten gevonden";
    }
    field.opts.tabindex = "-1";

    // field.opts.minimumResultsForSearch = -1;

    return field
}
